


































import Vue from 'vue';
import { Loading } from '@/components/ds';
import Modal from './Modal.vue';
import SearchCard, { CardInfo } from '../SearchCard/SearchCard.vue';
import { Campus, City } from '@/store/modules/location/state';
import SentryClient from '@/helpers/sentry';

interface Data {
  isLoadingCities: boolean;
  isLoadingCampi: boolean;
  isSubmitting: boolean;
  selectedCity?: City;
}

export default Vue.extend({
  components: { Modal, SearchCard, Loading },
  data(): Data {
    return {
      isLoadingCities: true,
      isLoadingCampi: false,
      isSubmitting: false,
      selectedCity: undefined,
    };
  },
  computed: {
    cities(): City[] {
      return this.$store.getters.availableCities;
    },
    citiesItems(): CardInfo[] {
      return this.cities.map(({ city, state }: City, index: number) => ({
        key: index,
        content: { title: `${city}, ${state}`, icon: 'location' },
      }));
    },
    campi(): Campus[] {
      return this.$store.getters.availableCampuses;
    },
    campiItems(): CardInfo[] {
      return this.campi.map(campus => {
        return {
          key: campus.id,
          content: {
            title: campus.name,
            data: [{ text: campus?.address }] as any,
          },
        };
      });
    },
    isLoading(): boolean {
      return this.isLoadingCities || this.isLoadingCampi || this.isSubmitting;
    },
    showCitiesForm(): boolean {
      return !this.isLoadingCities && !this.selectedCity;
    },
    showCampiForm(): boolean {
      return !this.isLoadingCampi && !!this.selectedCity;
    },
  },
  async mounted(): Promise<void> {
    try {
      await this.$store.dispatch('PULL_AVAILABLE_CITIES');
    } catch (error) {
      // Não fecha o modal: ele é o caminho de correção de quem chegou sem polo, e
      // fechar no erro tira essa correção da mão do candidato. Reabrir tenta de novo.
      this.$emit('error', 'changeCampusError.couldntLoadCities');
      SentryClient.captureError(error as any);
    } finally {
      this.isLoadingCities = false;
    }
  },
  methods: {
    async selectCity(selectedItem: CardInfo): Promise<void> {
      const city = this.cities[selectedItem.key];
      this.selectedCity = city;
      this.isLoadingCampi = true;

      try {
        this.$store.dispatch('UPDATE_CITY', { city });
        await this.$store.dispatch('PULL_AVAILABLE_CAMPUSES');
      } catch (error) {
        // Volta para a lista de cidades em vez de fechar, para o candidato escolher
        // outra cidade ou tentar a mesma de novo.
        this.selectedCity = undefined;
        this.$emit('error', 'changeCampusError.couldntLoadCampus');
        SentryClient.captureError(error as any);
      } finally {
        this.isLoadingCampi = false;
      }
    },
    async selectCampus(selectedItem: CardInfo): Promise<void> {
      const campus = this.campi.find(campus => campus.id === selectedItem.key);

      this.isSubmitting = true;

      try {
        await this.$store.dispatch('UPDATE_CAMPUS', { campus });
        // Fecha só no sucesso. No erro o modal continua aberto com a mensagem: o polo
        // segue o antigo e o candidato precisa poder tentar de novo.
        this.closeModal();
      } catch (error) {
        this.$emit('error', 'changeCampusError.couldntChangeCampus');
        SentryClient.captureError(error as any);
      } finally {
        this.isSubmitting = false;
      }
    },
    closeModal(): void {
      this.$emit('closeModal');
    },
  },
});
